// extracted by mini-css-extract-plugin
module.exports = {"ellipses":"pagination_ellipses__w5oyL"};